<template>
	<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageSubtitle="pageSubtitle" :pageTitle="pageTitle" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon">
	</header-layout>
	<div class="container mt-n10">
		<div class="row mt-5" v-if="this.$store.getters.loggedIn">
			
			<!--  ACCES RAPID VENTE-->
			<div class="col-md-12" v-if="$store.getters.isAuthorized([ 'ROLE_VENTE'])">
				<div class="card border-top-lg border-bottom-xs border-right-xs border-left-xs border-info">
					<div class="card-header">
						<div class="row ">
							<div class="col-md-2">
								<div class="rounded-circle bg-info text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'prodorder'}" :title="$t('prodorder.new')" class="align-center text-white">
										<fa icon="cart-plus"/>
										<br> {{ $t('prodorder.new') }}
									</router-link>
								</div>
							</div>
							<div class="col-md-2">
								<div class="rounded-circle bg-warning text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:17, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitsp')"> 
										<fa icon="signal"/>
										<br>{{ $t('mvtmovement.button.debitsp') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-2">
								<div class="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:12, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitdj')"> 
										<fa icon="coffee"/>
										<br>{{ $t('mvtmovement.button.debitdj') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-2">
								<div class="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:8, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitaf')"> 
										<fa icon="question-circle"/>
										<br>{{ $t('mvtmovement.button.debitaf') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-2">
								<div class="rounded-circle bg-info text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:21, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitft')"> 
										<fa icon="bus"/>
										<br>{{ $t('mvtmovement.button.debitft') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-2">
								<div class="rounded-circle bg-danger text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:NaN, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debit')"> 
										<fa icon="minus-circle"/>
										<br>{{ $t('mvtmovement.button.debit') }}
									</router-link>
									
								</div>
							</div>
							
						</div>

					</div>
					<!-- <div class="card-body">
						

					</div> -->
				</div>
			</div>
			<!--  ACCES RAPID MANAGER-->
			<div class="col-md-12" v-if="$store.getters.isAuthorized(['ROLE_MANAGER'])">
				<div class="card border-top-lg border-bottom-xs border-right-xs border-left-xs border-info">
					<div class="card-header">
						
						<div class="row">
							<div class="col-md-3">
								<div class="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'servteamop'}" class="align-center text-white" :title="$t('servteam.new')">
										<fa icon="random"/>
										<br>{{ $t('servteam.new') }}
									</router-link>
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-success text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'servorder'}" class="align-center text-white" :title="$t('servorder.new')">
										<fa icon="sticky-note"/>
										<br>{{ $t('servorder.new') }}
									</router-link>
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'prsperson', params: {type:2}}" class="align-center text-white" :title="$t('prsperson.button.cl')">
										<fa icon="address-card"/>
										<br>{{ $t('prsperson.button.cl') }}
									</router-link>
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-info text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'prsperson', params: {type:1}}" class="align-center text-white" :title="$t('prsperson.button.ep')">
										<fa icon="address-book"/>
										<br>{{ $t('prsperson.button.ep') }}
									</router-link>
								</div>
							</div>
							
							
						</div>
						<hr class="hr" />
						<div class="row">
							<div class="col-md-3">
								<div class="rounded-circle bg-warning text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:25, accId:1, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitfru')"> 
										<fa icon="industry"/>
										<br>{{ $t('mvtmovement.button.debitfru') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:7, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitpf')"> 
										<fa icon="calculator"/>
										<br>{{ $t('mvtmovement.button.debitpf') }}
									</router-link>
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-info text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:6, accId:1, typeAdd:'vcc'} }" class="align-center text-white" :title="$t('mvtmovement.newvcc')"> 
										<fa icon="recycle"/>
										<!-- exchange -->
										<br>{{ $t('mvtmovement.newvcc') }}
									</router-link>
									
								</div>
							</div>
							<div class="col-md-3">
								<div class="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
									style="width: 150px; height: 150px;">
									<router-link 
										v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:2, accId:NaN, typeAdd:'one'} }" class="align-center text-white" :title="$t('mvtmovement.button.debitel')"> 
										<fa icon="microchip"/>
										<br>{{ $t('mvtmovement.button.debitel') }}
									</router-link>
									
								</div>
							</div>
							
						</div>

					</div>
					<!-- <div class="card-body">
						

					</div> -->
				</div>
			</div>
			<!-- 1 - Financial -->
			<div class="col-md-12 p-2" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])">
				<div class="card border-top-lg border-bottom-lg border-right-lg border-left-lg border-success">
					<div class="card-header">
						<h2 class="align-center">
							ARRÊTÉ(S) DE CAISSE EN COURS (<FONT color="#C50E0E">{{instanceClassAttrFinancial.items.length}}</FONT>)
						</h2>

					</div>
					<div class="card-body">
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttrFinancial"
								ref="componentDatatableFinancial" :key="keyDatatableFinancial"
							/>
						</div>

					</div>
				</div>
			</div>

			<!-- 2 - ServOrder -->
			<div class="col-md-12 p-2" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])">
				<div class="card border-top-lg border-bottom-lg border-right-lg border-left-lg border-warning">
					<div class="card-header">
						<h2 class="align-center">
							BONS DE LIVRAISON EN COURS (<FONT color="#C50E0E">{{instanceClassAttrServOrder.items.length}}</FONT>)
						</h2>
					</div>
					<div class="card-body">
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttrServOrder"
								ref="componentDatatableServOrder" :key="keyDatatableServOrder"
							/>
						</div>

					</div>
				</div>
			</div>

			<!-- 3 - ServTeam -->
			<div class="col-md-12 p-2" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])">
				<div class="card border-top-lg border-bottom-lg border-right-lg border-left-lg border-info">
					<div class="card-header">
						<h2 class="align-center">
							FICHES DE SUIVI (<FONT color="#C50E0E">{{instanceClassAttrServTeam.items.length}}</FONT>)
						</h2>
					</div>
					<div class="card-body">
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttrServTeam"
								ref="componentDatatableServTeam" :key="keyDatatableServTeam"
							/>
						</div>

					</div>
				</div>
			</div>
			
		</div>
		<!-- <div class="row">
			<div class="col-xxl-6 mb-4" v-if="$store.getters.isAuthorized(['ROLE_ADMIN','ROLE_MANAGER','ROLE_SUIVI','ROLE_VENTE'])">
				<div class="d-flex justify-content-between">    
					<div class="">

						
					</div>
				</div>
			</div>

		</div> -->
	</div>
</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	export default {
		name: 'dashboard',
		// mixins: [linkActivationMixin],
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
		},

		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-4',
				pageHeaderContainer: 'container',
				pageSubtitle: 'Dashboard subtitle',
				pageTitle: 'Dashboard',
				pageIcon: 'dashboard',
				instanceClassAttr: {
					instanceClass: 'dashboard'
				},
				dashMap:{},
				instanceClassAttrFinancial: {
					instanceClass: 'mvtfinancialstatement',
					routerShow: 'mvtfinancialstatementshow',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '6%', 
						actAdd: false, 
						actGet: true, 
						actEdit: false, 
						actDel: false
					},
					attrsList: [
						{attrName: 'prsStoreLib', attrCol: '11%', searchable: true, sortable: true, thClass:'align-center'},
						{attrName: 'dateStart', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'dateEnd', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'amountDebit', attrCol: '12%', searchable: false, sortable: true, thClass:'align-right'},
						{attrName: 'amountCredit', attrCol: '12%', searchable: false, sortable: true, thClass:'align-right'},
						{attrName: 'accountTot', attrCol: '12%', searchable: false, sortable: true, thClass:'align-right'},
						{attrName: 'activeLib', attrCol: '7%', searchable: false, sortable: true},
					],
					items:[]
				},
				keyDatatableFinancial:0,
				instanceClassAttrServOrder: {
					instanceClass: 'servorder',
					routerShow: 'servordershow',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true,
						// actAlign: 'right',
						thCol: '10%', 
						actAdd: false, 
						actGet: true, 
						actEdit: false, 
						actDel: false
					},
					attrsList: [
						{attrName: 'orderNumber', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'prsStoreLib', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'orderDate', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'servStatusLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'servOp', attrCol: '35', searchable: false, sortable: true},
						{attrName: 'usernameLib', attrCol: '10%', searchable: true, sortable: false}
					],
					items:[]
				},
				keyDatatableServOrder:0,
				instanceClassAttrServTeam: {
					instanceClass: 'servteam',
					routerShow: 'servteamshow',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true,
						// actAlign: 'right',
						thCol: '10%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true
					},
					attrsList: [
						{attrName: 'prsTeamLib', attrCol: '25%', searchable: false, sortable: true},
						{attrName: 'servDate', attrCol: '15%', searchable: false, sortable: true},
						// {attrName: 'servTypeLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'servOp', attrCol: '35', searchable: false, sortable: true},
						{attrName: 'usernameLib', attrCol: '10%', searchable: true, sortable: false}
					],
					items:[]
				},
				keyDatatableServTeam:0,


				/*optionsAlert: [
					{ value: null, text: this.$t('workflow.filtertasks.seealltasks') },
					{ value: 'duedate', text: this.$t('workflow.filtertasks.seeduetasks') },
					{ value: 'days7', text: this.$t('workflow.filtertasks.seecreatedtasks7days') },
					{ value: 'days14', text: this.$t('workflow.filtertasks.seecreatedtasks14days') },
					{ value: 'days30', text: this.$t('workflow.filtertasks.seecreatedtasks30days') },
				],*/
				/*fields: [
					{
						key: 'record',
						label: this.$t('dosdossier.label'),
						sortable: false,
						visible: false
					},
					{
						key: 'name',
						label: this.$t('workflow.steps.label'),
						sortable: true
					},			
					{
						key: 'createTime',
						label: this.$t('workflow.steps.CreatedAt'),
						formatter: "formatDateAssigned"
					},               
					{
						key: 'assignee',
						label: this.$t('workflow.steps.Assignee'),
					},
					{
						key: 'commands',
						label: this.$t('workflow.steps.commands'),
						class: 'table-commands-width'
					}
				],
				codetasks: [],
				notasksforyou: false,
				notasksforyourgroup: false,
				notasksunassigned: false,
				selectedAlert: null,*/
			}
		},
		/*watch: {
			'$store.getters.language': function() {
				this.optionsAlert = [
					{ value: null, text: this.$t('workflow.filtertasks.seealltasks') },
					{ value: 'duedate', text: this.$t('workflow.filtertasks.seeduetasks') },
					{ value: 'days7', text: this.$t('workflow.filtertasks.seecreatedtasks7days') },
					{ value: 'days14', text: this.$t('workflow.filtertasks.seecreatedtasks14days') },
					{ value: 'days30', text: this.$t('workflow.filtertasks.seecreatedtasks30days') },
				];
				this.fields = [
					{
						key: 'record',
						label: this.$t('dosdossier.label'),
						sortable: false,
						visible: false
					},
					{
						key: 'name',
						label: this.$t('workflow.steps.label'),
						sortable: true
					},			
					{
						key: 'createTime',
						label: this.$t('workflow.steps.CreatedAt'),
						formatter: "formatDateAssigned"
					},               
					{
						key: 'assignee',
						label: this.$t('workflow.steps.Assignee'),
					},
					{
						key: 'commands',
						label: this.$t('workflow.steps.commands'),
						class: 'table-commands-width'
					}
				]
			}
		},*/
		// created() {
			
		// },
		mounted() {
			this.dashboard()
		},
		methods: {
			async dashboard() {
				await this.$store.dispatch('axiosGet', { url: '/api/dashboard'
				})
				.then(response => {
					if(response.data){
						// console.log('response.data === ', response.data)
						// this.dashMap = response.data;
						this.instanceClassAttrFinancial.items = response.data.mvtFinancial
						this.keyDatatableFinancial = this.keyDatatableFinancial +1;
						
						this.instanceClassAttrServOrder.items = response.data.servOrderList
						this.keyDatatableServOrder = this.keyDatatableServOrder +1;

						this.instanceClassAttrServTeam.items = response.data.servTeamList
						this.keyDatatableServTeam = this.keyDatatableServTeam +1;
					}
				})
				.catch(error => {
					console.log('error catch -dashMap == ', error.message)
				})		
			},
			/*changeOptions(){
				this.refreshTaskList();
			},*/
			/*refreshTaskList(event){
				for (const code of this.codetasks){
					this.$refs['home-tasklist-yours-'+code][0].refresh();
					this.$refs['home-tasklist-group-'+code][0].refresh();
					this.$refs['home-tasklist-unassigned-'+code][0].refresh();                    
				}
			},
			refreshMessage(){
				let count = {
					yours: 0, group: 0, unassigned: 0
				}
				for (let obj in this.$refs){
					if (obj.indexOf('yours') > 0)
						count['yours'] += this.$refs[obj][0].nbRows() 
					else if (obj.indexOf('group') > 0)
						count['group'] += this.$refs[obj][0].nbRows()
					else if (obj.indexOf('unassigned') > 0)
						count['unassigned'] += this.$refs[obj][0].nbRows()
				}
				this.notasksforyou = count.yours == 0
				this.notasksforyourgroup = count.group == 0
				this.notasksunassigned = count.unassigned == 0

			}*/
		}

	}
</script>